import React from 'react';
import Projects from '../components/Projects';

const ProjectsPage: React.FC = () => {
  return (
    <Projects />
  );
};

export default ProjectsPage; 